module.exports = __webpack_public_path__ + "img/slovakia-min.f032c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries/slovakia-min.png
// module id = 1EaH
// module chunks = 1